import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Button,
  getTranslation,
  ProfilePhoto,
  TranslationProvider,
} from '@resy/ui-kitchen';
import { loadResyConfigThunk } from '../../../../../../ui-kitchen/src/reducers';
import { IDLE } from '../../../../../../ui-kitchen/src/constants/asyncLoadingStatuses';
import Menu from '../../Menu';
import menuItemsConfig from '../../../containers/MenuContainer/menuItems';
import './DeltaWifiMenuContainer.scss';

class DeltaWifiMenuContainer extends React.Component {
  static propTypes = {
    $location: PropTypes.shape({
      search: PropTypes.func,
    }).isRequired,
    $rootScope: PropTypes.shape({
      nav: PropTypes.shape(),
    }).isRequired,
    $route: PropTypes.shape({
      reload: PropTypes.func,
    }).isRequired,
    Analytics: PropTypes.shape({
      event: PropTypes.func,
    }).isRequired,
    configStatus: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    isConciergeUser: PropTypes.bool.isRequired,
    isGdaEnabled: PropTypes.bool,
    isLoggedIn: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    isGda: PropTypes.bool,
    onLogin: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    profilePhotoUrl: PropTypes.string,
    isNonUS: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isGda: false,
    isGdaEnabled: false,
    profilePhotoUrl: null,
  }

  state = {
    menuItems: [],
  }

  componentDidMount = () => {
    const { configStatus, dispatch } = this.props;
    if (configStatus === IDLE) {
      dispatch(loadResyConfigThunk());
    }
    this.generateMenuItems();
  }

  componentDidUpdate = (prevProps) => {
    const { isLoggedIn, isGdaEnabled } = this.props;
    if (isLoggedIn !== prevProps.isLoggedIn || isGdaEnabled !== prevProps.isGdaEnabled) {
      this.generateMenuItems();
    }
  }

  generateMenuItems = async () => {
    const {
      isConciergeUser,
      isGdaEnabled,
      isLoggedIn,
      isMobile,
    } = this.props;

    let menuItems = [];

    if (isMobile) {
      if (!isLoggedIn) {
        menuItems = [
          ...(isGdaEnabled ? menuItemsConfig.gda : []),
          ...menuItemsConfig.loggedOut,
        ];
      } else {
        menuItems = [
          ...(isConciergeUser ? menuItemsConfig.concierge : []),
          ...menuItemsConfig.loggedIn,
          { key: 'dividerKey', name: 'divider' },
          ...(isGdaEnabled ? menuItemsConfig.gda : []),
          ...menuItemsConfig.loggedOut,
        ];
      }
    } else {
      menuItems = [
        ...(isConciergeUser ? menuItemsConfig.concierge : []),
        ...menuItemsConfig.loggedIn,
        { key: 'dividerKey', name: 'divider' },
      ];
    }

    this.setState({ menuItems });
  }

  login = () => {
    const { onLogin } = this.props;

    onLogin();
  }

  renderDesktop = () => {
    const {
      isLoggedIn,
      isOpen,
      isGda,
      onOpen,
      profilePhotoUrl,
    } = this.props;

    return (
      <>
        {!isLoggedIn && (
          <TranslationProvider translationKey="login">
            <Button
              variant="login"
              onClick={this.login}
              data-test-id="menu_container-button-log_in"
            >
              Log in
            </Button>
          </TranslationProvider>
        )}

        {isLoggedIn && (
          <Button
            aria-expanded={isOpen}
            variant="no-style"
            className={cx('ResyIcon__container',
              { 'ResyIcon__container--rga': isGda })}
            onClick={onOpen}
            data-test-id="menu_container-button-profile_photo"
            data-dd-privacy="mask"
          >
            <ProfilePhoto
              isGda={isGda}
              url={profilePhotoUrl}
            />
          </Button>
        )}
        {isLoggedIn && isOpen && this.renderMenuAndAuthButtonForDesktop()}
      </>
    );
  }

  renderMenuAndAuthButtonForDesktop = () => {
    const {
      Analytics,
      onLogout,
      onOpen,
    } = this.props;
    const {
      menuItems,
    } = this.state;

    return (
      <div className="DeltaWifiMenuContainer__menu-and-auth-button">
        <Button
          aria-label={getTranslation({
            translationKey: 'close_menu',
            fallback: 'close menu',
          })}
          variant="close"
          className="DeltaWifiMenuContainer__close-container"
          onClick={onOpen}
          data-test-id="menu_container-button-close"
        />
        <Menu Analytics={Analytics} items={menuItems} />
        <div className="DeltaWifiMenuContainer__auth-button-container logged-in">
          <TranslationProvider translationKey="signout">
            <Button
              variant="no-style"
              onClick={onLogout}
              data-test-id="menu_container-button-logout"
            >
              Sign out
            </Button>
          </TranslationProvider>
        </div>
      </div>
    );
  }

  renderMenuAndAuthButtonForMobile = () => {
    const {
      Analytics,
      isLoggedIn,
      isOpen,
      onLogout,
      isNonUS,
    } = this.props;
    const {
      menuItems,
    } = this.state;

    if (!isLoggedIn) {
      return (
        <div
          className={cx('DeltaWifiMenuContainer__menu-and-auth-button', {
            'DeltaWifiMenuContainer__menu-and-auth-button--open': isOpen,
          })}
        >
          <Menu Analytics={Analytics} items={menuItems} isNonUS={isNonUS} />
          <div className="DeltaWifiMenuContainer__auth-button-container logged-out">
            <TranslationProvider translationKey="login">
              <Button
                variant="login"
                onClick={this.login}
                data-test-id="menu_container-button-login"
              >
                Log in
              </Button>
            </TranslationProvider>
          </div>
        </div>
      );
    }

    return (
      <div
        className={cx('DeltaWifiMenuContainer__menu-and-auth-button', {
          'DeltaWifiMenuContainer__menu-and-auth-button--open': isOpen,
        })}
      >
        <Menu Analytics={Analytics} items={menuItems} isNonUS={isNonUS} />
        <div className="DeltaWifiMenuContainer__auth-button-container logged-in">
          <TranslationProvider translationKey="signout">
            <Button
              variant="no-style"
              onClick={onLogout}
              data-test-id="menu_container-button-sign_out"
            >
              Sign out
            </Button>
          </TranslationProvider>
        </div>
      </div>
    );
  }

  renderMobilePage = () => {
    const {
      isLoggedIn,
      isOpen,
      isGda,
      onOpen,
      profilePhotoUrl,
    } = this.props;

    return (
      <>
        {!isLoggedIn && (
          <TranslationProvider translationKey="login">
            <Button
              variant="login"
              onClick={this.login}
              data-test-id="menu_container-button-log_in"
            >
              Log in
            </Button>
          </TranslationProvider>
        )}

        {isLoggedIn && !isOpen && (
          <Button
            aria-expanded={isOpen}
            variant="no-style"
            className={cx('ResyIcon__container',
              { 'ResyIcon__container--rga': isGda })}
            onClick={onOpen}
            data-test-id="menu_container-button-profile_photo"
            data-dd-privacy="mask"
          >
            <ProfilePhoto
              isGda={isGda}
              url={profilePhotoUrl}
            />
          </Button>
        )}
        {isLoggedIn && isOpen && this.renderMenuAndAuthButtonForMobile()}
      </>
    );
  }

  render() {
    const {
      isMobile,
    } = this.props;

    return (
      <div
        className={cx('DeltaWifiMenuContainer', {
          'DeltaWifiMenuContainer--mobile': isMobile,
          'DeltaWifiMenuContainer--desktop': !isMobile,
        })}
      >
        {isMobile && this.renderMobilePage()}
        {!isMobile && this.renderDesktop()}
      </div>
    );
  }
}

const mapStateToProps = ({ resyConfig, ipdata }) => ({
  configStatus: resyConfig.configStatus,
  isGdaEnabled: resyConfig.config?.enable_global_dining_access,
  isNonUS: ipdata?.isNonUS,
});

DeltaWifiMenuContainer.displayName = 'DeltaWifiMenuContainer';

export { DeltaWifiMenuContainer as ComponentUnderTest };
export default connect(mapStateToProps)(DeltaWifiMenuContainer);
